// extracted by mini-css-extract-plugin
module.exports = {"button":"linkButton-module--button--3bIdt","symbol":"linkButton-module--symbol--2gvbp"};